/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_5_1Inputs */



/**
* | output |
* | --- |
* | "Regular review and updates of your templates" |
*
* @param {Guardrails_Section_5_1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_5_1 = /** @type {((inputs?: Guardrails_Section_5_1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_5_1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Regelmäßige Überprüfung und Aktualisierung Ihrer Templates")
	return /** @type {LocalizedString} */ ("Regular review and updates of your templates")
});